import { __assign } from '../../_virtual/_tslib.js';
import { ApolloLink } from '@apollo/client';

function addRequestHeaders(headersToAdd) {
    return new ApolloLink(function (operation, forward) {
        var headers = typeof headersToAdd === 'function' ? headersToAdd(operation) : headersToAdd;
        if (Object.keys(headers).length > 0) {
            operation.setContext({
                headers: __assign(__assign({}, operation.getContext().headers), headers)
            });
        }
        return forward(operation);
    });
}

export default addRequestHeaders;
//# sourceMappingURL=addRequestHeaders.js.map
